import { createContext } from 'react';
import type { Site } from '@hotjar/site';
import type { ProductCatalog } from '../external-dependencies/domains/product/types';

export interface TrialsLegacyContextInterface {
  isLoading: boolean;
  sites: Array<Site> | undefined;
  productCatalog: ProductCatalog | undefined;
  currentSite: Site | undefined;
}

export const TrialsLegacyContext = createContext<TrialsLegacyContextInterface>({
  isLoading: true,
  sites: [],
  // TODO remove the productCatalog when fully migrated to Billing 3.0
  productCatalog: undefined,
  currentSite: undefined,
});
